import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from 'sonner';
import './i18n'; // Initialize i18n
import './ui/theme.css'; // Dark agro-tech design system
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Fields from './pages/Fields';
import FieldDetails from './pages/FieldDetails';
import Subscription from './pages/Subscription';
import Settings from './pages/Settings';
import AgronomistDashboard from './pages/AgronomistDashboard';
import Admin from './pages/Admin';
import WeatherMap from './pages/WeatherMap';
import ProtectedRoute from './components/ProtectedRoute';
import AgronomistRoute from './components/AgronomistRoute';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import './App.css';

// Remove platform-injected badges
const removeBadges = () => {
  const selectors = [
    '[class*="emergent"]',
    '[id*="emergent"]',
    'a[href*="emergent"]',
    '[class*="made-with"]',
    '[class*="powered-by"]'
  ];
  
  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      if (el && el.parentNode) {
        el.style.display = 'none';
        el.style.visibility = 'hidden';
        el.style.opacity = '0';
      }
    });
  });
  
  // Also check for fixed positioned elements in bottom-right
  document.querySelectorAll('body > div, body > a').forEach(el => {
    const style = window.getComputedStyle(el);
    if (style.position === 'fixed' && 
        (el.innerText?.toLowerCase().includes('emergent') ||
         el.innerHTML?.toLowerCase().includes('emergent'))) {
      el.style.display = 'none';
    }
  });
};

function App() {
  // Remove badges on mount and periodically
  useEffect(() => {
    removeBadges();
    const interval = setInterval(removeBadges, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/fields" element={<ProtectedRoute><Fields /></ProtectedRoute>} />
          <Route path="/fields/:fieldId" element={<ProtectedRoute><FieldDetails /></ProtectedRoute>} />
          <Route path="/subscription" element={<ProtectedRoute><Subscription /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="/weather-map" element={<ProtectedRoute><WeatherMap /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
          <Route path="/agronomist" element={<AgronomistRoute><AgronomistDashboard /></AgronomistRoute>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <PWAInstallPrompt />
        <Toaster 
          position="top-right" 
          toastOptions={{
            style: {
              background: 'rgba(12,35,26,0.92)',
              backdropFilter: 'blur(14px)',
              color: 'rgba(255,255,255,0.92)',
              border: '1px solid rgba(255,255,255,0.08)',
              borderRadius: 12,
            }
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
